module.exports = __webpack_public_path__ + "static/media/RP-A_S_Fashion_Sempione.e599ab13.png";